

































import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import segmentIo from '@/utils/segment.io';
import BusinessService from '@/api/BusinessService';
import Loading from '@/components/icons/Loading.vue';

@Component({
  components: {
    Typography,
    Loading
  }
})
export default class ScheduledBar extends Vue {
  @Prop() dateTime!: string;
  businessService = new BusinessService();

  loading = false;

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  async onClick() {
    segmentIo.track('Clicked Reschedule Onboarding Call Banner');

    if (!this.business.onboardingMeeting.rescheduleLink) {
      try {
        this.loading = true;

        const { data } = await this.businessService.getBusinessInfo();
        data.manager = data.loggedInManager;
        this.$store.dispatch('business/SET_BUSINESS_INFO', data);

        if (!this.business.onboardingMeeting.rescheduleLink) {
          this.$notification(
            'We did not receive the meeting data yet, try again later',
            'error'
          );
          return;
        }
      } finally {
        this.loading = false;
      }
    }

    if (this.business.onboardingMeeting.rescheduleLink) {
      window.open(this.business.onboardingMeeting.rescheduleLink, '_blank');
    }
  }
}
